import React from 'react';
import PropTypes from 'prop-types';
import Tab from './components/tab';

const TAB_COUNT = 6;

const TabSelector = ({ selectedId = null, disabledTabs = null, onClick }) => (
  <div className="ws-ui-tab-selector">
    {Array.from({ length: TAB_COUNT }, (_, i) => i + 1).map((tabId) => (
      <Tab
        key={tabId}
        label={tabId}
        selected={tabId === selectedId}
        disabled={disabledTabs?.includes(tabId)}
        onClick={() => onClick(tabId)}
      />
    ))}
  </div>
);

TabSelector.propTypes = {
  selectedId: PropTypes.string,
  disabledTabs: PropTypes.arrayOf(PropTypes.number),
  onClick: PropTypes.func.isRequired,
};

export default TabSelector;
